<template>
  <div style="padding: 0.5em" class="card-box-client">
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="得意先一覧" name="list"></el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <searchList></searchList>
    </div>

  </div>
</template>

<script>
  import searchList from '../daikan/daikanSearchList'

  export default {
    data() {
      return {
        activeName: 'list'
      }
    },
    methods: {
      activeChg(chg) {
        this.activeName = chg
      }
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          return false
        }
      })
    },
    created() {
    },
    components: {
      searchList
    }
  }
</script>
<style>
  .card-box-client {
    padding: 2em;
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 1em auto;
    height: 55em;
    width: 95em;
    border: 0.1em solid #8492A6;
  }
</style>



// WEBPACK FOOTER //
// src/components/daikan/daikanClientList.vue